import { render, staticRenderFns } from "./QuickEditShippingExpenseModal.vue?vue&type=template&id=653c4d39&scoped=true"
import script from "./QuickEditShippingExpenseModal.vue?vue&type=script&lang=js"
export * from "./QuickEditShippingExpenseModal.vue?vue&type=script&lang=js"
import style0 from "./QuickEditShippingExpenseModal.vue?vue&type=style&index=0&id=653c4d39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c4d39",
  null
  
)

export default component.exports